export function SinglesPrintRow({ row, event, type, background, className }) {
  if (!row || !event) return null;

  return (
    <tr
      style={{
        border: "1px solid #000",
        borderTop: "none",
        "@media print": { printColorAdjust: "exact" },
        backgroundColor: background ? "#dddddd" : "transparent",
        textOverflow: "ellipsis",
        width: "100%",
        display: "table-row",
        padding: "4px 8px"
      }}
      className={className}
    >
      <td style={{ textAlign: "center" }}>{row?.table}</td>
      <td>
        {type !== "lastName"
          ? row?.player?.name || "---"
          : `${row?.player?.lastName ? row.player.lastName + ", " : ""}${row?.player?.firstName || "---"}`}
      </td>
      <td style={{ textAlign: "center" }}>{row?.player?.points}</td>
      <td style={{ textAlign: "center" }}>vs</td>
      <td style={{ textAlign: "center" }}>{row?.opponent?.points}</td>
      <td>
        {type !== "lastName"
          ? row?.opponent?.name || "---"
          : `${row?.opponent?.lastName ? row.opponent.lastName + ", " : ""}${row?.opponent?.firstName || "---"}`}
      </td>
    </tr>
  );
}

export function DoublesPrintRow({ row, event }) {
  if (!row || !event) return null;

  const doubleRowStyle = {
    border: "1px solid #000",
    borderTop: "none",
    textOverflow: "ellipsis",
    width: "100%",
    display: "table-row",
    padding: "4px 8px"
  };

  return (
    <>
      <tr
        style={{
          ...doubleRowStyle,
          backgroundColor: "#dddddd",
          "@media print": { printColorAdjust: "exact" },
          fontWeight: "bold"
        }}
        className={"print-table-row-even"}
      >
        <td style={{ textAlign: "center" }}>{row?.table}</td>
        <td>{row?.name}</td>
        <td style={{ textAlign: "center" }}>{row?.points}</td>
        <td style={{ textAlign: "center" }}>vs</td>
        <td style={{ textAlign: "center" }}>{row?.opponent?.points}</td>
        <td>{row?.opponent?.name || "---"}</td>
      </tr>

      {/* Player Rows under double rows */}
      {row?.players?.length > 0 &&
        row.players.map((player, index) => (
          <tr
            style={{
              ...doubleRowStyle,
              backgroundColor: "transparent"
            }}
          >
            <td style={{ textAlign: "center" }}></td>
            <td>{player?.name || "---"}</td>
            <td style={{ textAlign: "center" }}></td>
            <td style={{ textAlign: "center" }}></td>
            <td style={{ textAlign: "center" }}></td>
            <td>{row?.opponent?.players?.[index]?.name || "---"}</td>
          </tr>
        ))}
    </>
  );
}

export function TeamPrintRow({ row, event }) {
  if (!row || !event) return null;

  const doubleRowStyle = {
    border: "1px solid #000",
    borderTop: "none",
    textOverflow: "ellipsis",
    width: "100%",
    display: "table-row",
    padding: "4px 8px"
  };

  return (
    <>
      <tr
        style={{
          ...doubleRowStyle,
          backgroundColor: "#dddddd",
          "@media print": { printColorAdjust: "exact" },
          fontWeight: "bold"
        }}
        className={"print-table-row-even"}
      >
        <td style={{ textAlign: "center" }}>{row?.table}</td>
        <td>{row?.teamPlayer1?.name}</td>
        <td style={{ textAlign: "center" }}>{row?.teamPlayer1?.points}</td>
        <td style={{ textAlign: "center" }}>vs</td>
        <td style={{ textAlign: "center" }}>{row?.teamPlayer2?.points}</td>
        <td>{row?.teamPlayer2?.name || "---"}</td>
      </tr>

      {/* Player Rows under double rows */}
      {row?.pairings?.length > 0 &&
        row.pairings.map((pairing, index) => (
          <tr
            style={{
              ...doubleRowStyle,
              backgroundColor: "transparent"
            }}
          >
            <td style={{ textAlign: "center" }}>{pairing?.table}</td>
            <td>{pairing?.player1?.name || "---"}</td>
            <td style={{ textAlign: "center" }}>
              {pairing?.player1?.points || "---"}
            </td>
            <td style={{ textAlign: "center" }}>vs</td>
            <td style={{ textAlign: "center" }}>
              {pairing?.player2?.points || "---"}
            </td>
            <td>{pairing?.player2?.name || "---"}</td>
          </tr>
        ))}
    </>
  );
}

export function SeatedPrintRow({ row, event, type, background, className }) {
  if (!row || !event) return null;

  return (
    <tr
      style={{
        border: "1px solid #000",
        borderTop: "none",
        "@media print": { printColorAdjust: "exact" },
        backgroundColor: background ? "#dddddd" : "transparent",
        textOverflow: "ellipsis",
        width: "100%",
        display: "table-row",
        padding: "4px 8px"
      }}
      className={className}
    >
      <td style={{ textAlign: "center" }}>{row?.table}</td>
      <td>
        {type !== "lastName"
          ? row?.player?.name || "---"
          : `${row?.player?.lastName ? row.player.lastName + ", " : ""}${row?.player?.firstName || "---"}`}
      </td>
      <td>{row?.player?.seatName ? row.player.seatName : "---"}</td>
      <td style={{ textAlign: "center" }}>{row?.player?.points}</td>
      <td style={{ textAlign: "center" }}>{row?.player?.result}</td>
    </tr>
  );
}
